import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';

import { requestInform } from 'api/sfms/exchangeRate';
import Flex from 'components/common/Flex';
import MonthPicker from 'components/common-sfims/form/MonthPicker';
import formatNumber from 'utils/format/number';

/**
 * 대시보드 > 메인 대시보드 - 월 환율
 */
const ExchangeRate = ({ date, setDate }) => {
  /* state */
  // 목록
  const [datas, setDatas] = useState([]);

  /* watch */
  useEffect(() => {
    requestList();
  }, [date]);

  /* method */
  // 월 환율 목록 조회 요청
  const requestList = async () => {
    setDatas([]);

    const { list = [] } = await requestInform({
      exchangeYm: date
    });

    setDatas(list);
  };

  /* view */
  return (
    <Card className="mb-3">
      <Card.Body className="p-0">
        <Flex alignItems="center" direction="row">
          <h5 className="mb-0 me-7 ps-3 fs-0">
            <MonthPicker value={date} onUpdate={setDate} />
          </h5>
          <Row xxl={6} className="flex-1 m-0">
            {datas.map(({ rate, currency, nationCode } = {}, index) => (
              <Col
                key={`datas.${nationCode}`}
                className={classNames(
                  'py-3',
                  'text-end',
                  { 'border-end': index < datas.length - 1 },
                  'border-200',
                  'fs-2',
                  [
                    'text-dark',
                    'text-primary',
                    'text-success',
                    'text-info',
                    'text-warning',
                    'text-danger'
                  ][index % 6],
                  'fw-medium'
                )}
              >
                {formatNumber(rate, ',0.00') || '-'}
                <span className="fs-0 ms-1">{currency}</span>
              </Col>
            ))}
          </Row>
        </Flex>
      </Card.Body>
    </Card>
  );
};

ExchangeRate.propTypes = {
  // 월
  date: PropTypes.string,

  // 월 설정 함수
  setDate: PropTypes.func.isRequired
};
ExchangeRate.defaultProps = {
  date: moment()
    .add(moment().date() >= 22 ? 1 : 0, 'months')
    .format('YYYYMM')
};

export default ExchangeRate;
